import { Slide } from '@/components/slides/Slide.tsx';
import { FC, useEffect, useRef } from 'react';
import { useNavigation } from '@/navigation/NavigationContex.ts';
import { ICONS } from '@/Icons.tsx';
import { useCountdown } from '@/components/slides/Countdown/useCountdown.ts';
import { useReactOnSupergrid } from '@/util/useReactOnSupergrid.ts';
import { Slide as SlideType } from '@/eventConfig/types.ts';
import { useEventConfig } from '@/eventConfig/useEventConfig';
import { translate } from '@/translation/translate.ts';

interface CountdownSlideProps {
  className?: string;
  slide: SlideType;
}

export const CountdownSlide: FC<CountdownSlideProps> = ({ ...props }) => {
  const { next } = useNavigation();
  const { slide } = props;
  const { currentSlide } = useNavigation();
  const { eventConfig } = useEventConfig();
  const timerDuration = useRef<number>((currentSlide?.duration as number | undefined) ?? 1000);

  useReactOnSupergrid(['skipall', 'skipallnumeric'], () => {
    // On the "Skipall" and "skipallnumeric" supergrid, set the timer to just 5 sec
    timerDuration.current = 5;
  });

  const { startCountdown, resetCountdown, timerState, secsRemaining } = useCountdown(timerDuration.current);
  const displaySecs = String(secsRemaining % 60).padStart(2, '0');
  const displayMins = String(Math.floor(secsRemaining / 60)).padStart(2, '0');

  useEffect(() => {
    if (slide?.autoStart) {
      startCountdown();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (timerState == 'finished') {
      next();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timerState]);

  const progressIcons = ['anim-turnover fa-hourglass-end', 'fa-hourglass-half', 'fa-hourglass-start'];
  const finishedLabel = currentSlide?.finishedLabel
    ? translate(currentSlide?.finishedLabel)
    : translate(eventConfig?.translations.next);

  return (
    <Slide {...props} className="type-countdown">
      <div className={'countdown state-' + timerState}>
        <span className="time-remaining">
          <i className={'fas ' + progressIcons[secsRemaining % 3]} />
          {displayMins}:{displaySecs} min
        </span>
        <button className="start" onClick={startCountdown}>
          <i className="icon-start fas fa-play-circle" />
          {translate(currentSlide?.startLabel)}
        </button>
        <button className="restart" onClick={resetCountdown}>
          <i className="icon-restart fas fa-redo" />
          {translate(currentSlide?.restartLabel)}
        </button>
        <button className="finished" onClick={next}>
          {finishedLabel}
          <i className={'icon-next ' + ICONS.next} />
        </button>
      </div>
    </Slide>
  );
};
